<template>
  <div
    class="my-5 w-10 h-10 flex items-center justify-center rounded-full bg-gray-200 hover:bg-gray-300 cursor-pointer shadow-md transition"
  >
    <BackSvg @click="$router.go(-1)" />
  </div>
  <div
    class="h-48 bg-white border border-neutral-200 rounded-lg shadow-[0_10px_50px_rgba(0,0,0,0.1)] px-4 sm:px-6"
  >
    <div class="h-full flex items-center justify-between gap-4">
      <!-- Text -->
      <div class="flex-1 min-w-0">
        <h1 class="text-lg sm:text-xl text-orange-500 font-semibold mb-2">
          {{ translations.title }}
        </h1>

        <p class="text-sm text-neutral-600 leading-relaxed">
          {{ translations.description }}
        </p>
      </div>

      <!-- Image -->
      <div class="flex-shrink-0">
        <img
          :src="require('@/assets/images/customer-service.png')"
          alt="Customer Service"
          class="w-32 sm:w-36 md:w-40 h-auto object-contain"
        />
      </div>
    </div>
  </div>
  <div class="mt-5 space-y-3">
    <h3 class="py-2 font-semibold text-lg text-orange-500">
      {{ translations.header }}
    </h3>
  </div>

  <section class="my-6">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <!-- Card 1 -->
      <div
        class="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden group"
      >
        <video
          src="../../assets/infographic.mp4"
          controls
          class="w-full h-64 object-cover"
        ></video>

        <div class="p-4 text-center">
          <h2
            class="text-lg font-semibold text-orange-400 group-hover:text-blue-600 transition"
          >
            {{ translations.subtitleAvailment }}
          </h2>
          <p class="text-sm text-gray-500 mt-1">
            {{ translations.subdescriptionAvailment }}
          </p>
        </div>
      </div>

      <!-- Card 2 -->
      <div
        class="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden group"
      >
        <video
          src="../../assets/imf.mp4"
          controls
          class="w-full h-64 object-cover"
        ></video>

        <div class="p-4 text-center">
          <h2
            class="text-lg font-semibold text-orange-400 group-hover:text-blue-600 transition"
          >
            {{ translations.subtitleTelemed }}
          </h2>
          <p class="text-sm text-gray-500 mt-1">
            {{ translations.subdescriptionTelemed }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { ref, computed } from "vue";
import { useLanguage } from "@/utils/composables/useLanguage";
import BackSvg from "@/components/svgs/BackSvg.vue";

export default {
  components: { BackSvg },

  setup() {
    const { selectedLanguage } = useLanguage();
    const activeIndex = ref(null);
    const activeTab = ref("member");

    const translations = computed(
      () =>
        ({
          en: {
            title: "Welcome to the Information Center",
            description:
              "Access important information, member guides, and FAQs about IMS Wellth Care services.",
            header: "Member Help Videos",
            subtitleAvailment: "Availment Process",
            subdescriptionAvailment:
              "Learn the step-by-step process on how to avail healthcare benefits.",
            subtitleTelemed: "Teleconsultation Procedure",
            subdescriptionTelemed:
              "Understand how to consult with doctors through telemedicine services.",
          },
          ph: {
            title: "Maligayang Pagdating sa Information Center",
            description:
              "Makakuha ng mahahalagang impormasyon, gabay para sa mga miyembro, at mga madalas itanong tungkol sa mga serbisyo ng IMS Wellth Care.",
            header: "Mga Video na Gabay para sa mga Miyembro",
            subtitleAvailment: "Proseso sa paggamit ng benepisyo",
            subdescriptionAvailment:
              "Alamin ang sunod-sunod na proseso kung paano mag-avail ng mga benepisyong pangkalusugan.",
            subtitleTelemed: "Proseso ng Telekonsultasyon",
            subdescriptionTelemed:
              "Alamin kung paano makipagkonsulta sa doktor gamit ang serbisyong telemedicine.",
          },
        }[selectedLanguage.value])
    );
    const nonmemberFaqsEnglish = [
      {
        question: "Is my card transferable?",
        answer: `
          <p class="text-neutral-600 leading-7">
            No, it is intended for the primary cardholder only.
          </p>
        `,
      },
      {
        question:
          "Can my family members use the card for accredited hospitals/clinics?",
        answer: `
          <p class="text-neutral-600 leading-7">
            Extended coverage for family members may depend on the member's plan type. Eligible dependents (if single: parents aged 65 years old and below; if married: legal spouse aged 65 years old and below, and children aged 5 to 23 years old) may avail of free and unlimited consultations at partnered or owned clinics, as well as up to 30% discount on laboratory procedures.
          </p>
        `,
      },
      {
        question: "What are the nearest providers in my area?",
        answer: `
          <p class="text-neutral-600 leading-7">
            A directory of accredited providers will be provided upon receipt of your card. For the most up-to-date list of accredited providers, please visit our website or contact our 24/7 Customer Service Hotline for assistance.
          </p>
        `,
      },
      {
        question: "Can I also enroll my family members to the HMO program?",
        answer: `
          <p class="text-neutral-600 leading-7">
            Members enrolled under group or corporate plans may enroll their eligible dependents to the HMO program, subject to applicable terms, conditions, and plan requirements.
          </p>
        `,
      },
      {
        question: "Can I use the card for my common-law spouse?",
        answer: `
          <p class="text-neutral-600 leading-7">
            No. Only a legally married spouse aged 65 years old and below is considered an eligible dependent under the plan.
          </p>
        `,
      },
      {
        question:
          "Can I still use the card if I am no longer connected to the company?",
        answer: `
          <p class="text-neutral-600 leading-7">
            No. Coverage is based on the agreement between your employer and IWC. Once your employment is terminated, your eligibility for benefits under the company-sponsored plan also ends.
          </p>
        `,
      },
      {
        question: "What happens if I don't use my card?",
        answer: `
          <p class="text-neutral-600 leading-7">
            That's perfectly fine and may simply mean that you are healthy. However, please remember that your card provides not only medical benefits but also dental care benefits through hundreds of accredited dental clinics nationwide.
          </p>
        `,
      },
      {
        question: "Is there a return on investment (ROI)?",
        answer: `
          <p class="text-neutral-600 leading-7">
            No. As an HMO provider, IWC focuses on providing healthcare coverage and medical benefits. Unlike certain insurance products with investment components, HMO plans do not generate a return on investment.
          </p>
        `,
      },
      {
        question: "What happens to my deductions if I don't use the card?",
        answer: `
          <p class="text-neutral-600 leading-7">
            Monthly premiums will continue to be deducted regardless of card usage. Similar to insurance products, the purpose of maintaining HMO coverage is to ensure that you have access to healthcare benefits and financial protection when needed.
          </p>
        `,
      },
      {
        question: "What happens if I don't renew my plan?",
        answer: `
          <p class="text-neutral-600 leading-7">
            Your plan will be considered cancelled and you will no longer be eligible to avail of any benefits under the program.
          </p>
        `,
      },
      {
        question: "Do my benefits accumulate or accrue?",
        answer: `
          <p class="text-neutral-600 leading-7">
            No. Benefits do not accumulate or carry over. Unused benefits within the coverage period will expire based on the terms and conditions of your plan.
          </p>
        `,
      },
    ];
    const nonmemberFaqsTagalog = [
      {
        question: "Maililipat ba sa iba ang aking card?",
        answer: `
      <p class="text-neutral-600 leading-7">
        Hindi. Ang card na ito ay para lamang sa pangunahing cardholder at hindi maaaring ipagamit o ilipat sa ibang tao.
      </p>
    `,
      },
      {
        question:
          "Maaari bang gamitin ng aking mga kapamilya ang card sa mga accredited na ospital o klinika?",
        answer: `
      <div class="text-neutral-600 leading-7">
        <p>
          Ang pinalawak na benepisyo para sa mga miyembro ng pamilya ay nakadepende sa uri ng planong mayroon ang miyembro.
        </p>
        <p class="mt-3">
          Ang mga kwalipikadong dependents ay maaaring mag-avail ng libre at walang limitasyong konsultasyon sa alinmang partner o pagmamay-aring klinika, at makatanggap ng hanggang 30% diskuwento sa mga laboratory procedures.
        </p>
        <ul class="list-disc pl-5 mt-3">
          <li>Kung single ang miyembro: mga magulang na 65 taong gulang pababa.</li>
          <li>Kung may asawa ang miyembro: legal na asawa na 65 taong gulang pababa, at mga anak na edad 5 hanggang 23 taong gulang.</li>
        </ul>
      </div>
    `,
      },
      {
        question:
          "Ano ang mga pinakamalapit na accredited provider sa aking lugar?",
        answer: `
      <div class="text-neutral-600 leading-7">
        <p>
          Magbibigay kami sa inyo ng directory ng mga provider kasabay ng pagtanggap ninyo ng inyong card.
        </p>
        <p class="mt-3">
          Gayunpaman, mas mainam na bisitahin ang aming website para sa pinakabagong listahan ng mga accredited provider.
        </p>
        <p class="mt-3">
          Maaari rin kayong tumawag sa aming 24/7 customer service hotlines para sa anumang katanungan:
          0922-822-1033, 0922-822-1035, 0917-851-8645, at 0998-586-9439.
        </p>
        <p class="mt-3">
          Maaari rin kayong mag-message sa aming Messenger account na IMS Wellth Care.
        </p>
      </div>
    `,
      },
      {
        question:
          "Maaari ko rin bang i-enroll ang aking mga kapamilya sa HMO program?",
        answer: `
      <p class="text-neutral-600 leading-7">
        Ang mga miyembrong naka-enroll sa aming group o corporate plans ay maaaring mag-enroll ng kanilang mga dependent sa aming HMO program, alinsunod sa mga itinakdang kundisyon at patakaran.
      </p>
    `,
      },
      {
        question:
          "Maaari ko bang gamitin ang card para sa aking common-law spouse?",
        answer: `
      <p class="text-neutral-600 leading-7">
        Hindi. Ang itinuturing lamang na eligible dependent ay ang legal na asawa, basta’t siya ay 65 taong gulang pababa.
      </p>
    `,
      },
      {
        question:
          "Maaari ko pa bang gamitin ang card kung hindi na ako konektado sa kumpanya?",
        answer: `
      <p class="text-neutral-600 leading-7">
        Hindi. Dahil ang kasunduan ay nasa pagitan ng iyong kumpanya at IWC, ang iyong benepisyo ay hindi na maaaring magpatuloy kapag wala ka na sa kumpanya.
      </p>
    `,
      },
      {
        question: "Ano ang mangyayari kung hindi ko magamit ang aking card?",
        answer: `
      <div class="text-neutral-600 leading-7">
        <p>
          Mabuti iyon—ibig sabihin ay malusog ka!
        </p>
        <p class="mt-3">
          Gayunpaman, pakatandaan na ang card ay hindi lamang para sa medical benefits kundi may kasamang dental care benefits din, na maaari mong ma-avail sa mahigit 400 accredited dental clinics sa buong bansa.
        </p>
      </div>
    `,
      },
      {
        question: "May return on investment (ROI) ba?",
        answer: `
      <div class="text-neutral-600 leading-7">
        <p>
          Wala pong ROI dahil kami ay isang HMO company.
        </p>
        <p class="mt-3">
          Karaniwang may ROI lamang sa mga insurance na may variable component, kung saan ang bahagi ng premium ay ini-invest ng insurance company para sa policyholder.
        </p>
        <p class="mt-3">
          Gayunpaman, bilang HMO company, ang pokus ng IWC ay matiyak na kayo ay may sapat at maayos na medical coverage. Kaya naman, hindi kami nagbibigay ng ROI.
        </p>
      </div>
    `,
      },
      {
        question:
          "Ano ang mangyayari sa aking deductions kung hindi ko magamit ang card?",
        answer: `
      <div class="text-neutral-600 leading-7">
        <p>
          Magpapatuloy pa rin ang pag-deduct ng buwanang premium kahit ginagamit man o hindi ang card.
        </p>
        <p class="mt-3">
          Mahalagang tandaan na ang card ay laging kapaki-pakinabang dahil komprehensibo ang aming mga plano (halimbawa, kasama na ang dental benefits), kaya kahit ang mga malulusog na indibidwal ay nakikinabang pa rin dito.
        </p>
        <p class="mt-3">
          Gayunpaman, tulad ng ibang insurance products, ang pangunahing layunin ng HMO ay hindi upang mabawi ang binabayad na premium, kundi upang magbigay ng kapanatagan na kayo ay may financial protection sakaling kailanganin ang medical coverage.
        </p>
      </div>
    `,
      },
      {
        question: "Ano ang mangyayari kung hindi ko i-renew ang aking plan?",
        answer: `
      <p class="text-neutral-600 leading-7">
        Ang inyong plan ay ituturing na kanselado at hindi na kayo makaka-avail ng inyong mga benepisyo.
      </p>
    `,
      },
      {
        question: "Naiipon ba o nadadagdag ang aking mga benepisyo?",
        answer: `
      <p class="text-neutral-600 leading-7">
        Hindi. Ang inyong mga benepisyo ay hindi naiipon o nadadagdag sa paglipas ng panahon.
      </p>
    `,
      },
    ];

    const memberFaqsEnglish = [
      {
        question: "Why does the provider take so long to accommodate us?",
        answer: `
    <p class="text-neutral-600 leading-7">
      Providers, as well as our Customer Service Team, do their best to accommodate all members as promptly as possible. However, there may be instances when hospitals or clinics are attending to a high volume of patients at the same time. During these situations, we kindly ask for your patience and understanding as our providers work to serve everyone efficiently. Rest assured that you will be accommodated as soon as possible.
    </p>
  `,
      },
      {
        question: "Why is my doctor charging me for my availment?",
        answer: `
    <p class="text-neutral-600 leading-7">
      There are two common reasons why a doctor may charge additional fees during your availment:
    </p>

    <ul class="list-disc pl-5 mt-2 space-y-2 text-neutral-600">
      <li>
        Your remaining benefit limit may not be sufficient to fully cover the cost of the consultation, procedure, or treatment.
      </li>
      <li>
        The diagnosis, treatment, procedure, or service may not be covered under your healthcare plan.
      </li>
    </ul>
  `,
      },
      {
        question: "How do I know if my diagnosis is considered an exclusion?",
        answer: `
    <p class="text-neutral-600 leading-7">
      Our Medical Director will determine whether your diagnosis is considered an exclusion based on the medical information provided. Examples of exclusions may include Epilepsy, Autoimmune Diseases, Mental Disorders, and Sexually Transmitted Diseases (STDs).
    </p>

    <p class="text-neutral-600 leading-7 mt-3">
      For the complete list of exclusions, please visit:
      <a href="https://iwc.com.ph/help" target="_blank" class="text-orange-500 hover:underline">
        https://iwc.com.ph/help
      </a>
    </p>
  `,
      },
      {
        question: "Why do I have to pay for a Medical Certificate?",
        answer: `
    <p class="text-neutral-600 leading-7">
      Medical Certificates are not included in the plan coverage and are therefore chargeable to the member.
    </p>

    <p class="text-neutral-600 leading-7 mt-3">
      However, IWC offers TeleConsult services with free and unlimited consultations. Medical Certificates issued through TeleConsult are provided free of charge.
    </p>
  `,
      },
      {
        question:
          "What should I do if I encounter an issue while generating an LOA in AMAP?",
        answer: `
    <ol class="list-decimal pl-5 space-y-2 text-neutral-600">
      <li>Check that your internet connection is stable.</li>
      <li>Wait for five (5) minutes.</li>
      <li>Try generating the LOA again.</li>
      <li>
        If the issue persists, please email:
        <strong>contact@amap.iwcsrvr.com</strong>
      </li>
    </ol>
  `,
      },
      {
        question:
          "What should I do if I encounter a problem with TeleMed registration?",
        answer: `
    <p class="text-neutral-600 leading-7">
      Please follow the step-by-step instructions provided in the TeleMed brochure included in your kit and ensure that all information entered is accurate.
    </p>

    <p class="text-neutral-600 leading-7 mt-3">
      If you continue to experience issues during registration, please contact:
      <strong>contact@interactivemedicalfacilities.com</strong>
    </p>

    <p class="mt-3">
      <a
        href="https://bit.ly/4ueGD7u"
        target="_blank"
        class="text-orange-500 hover:underline"
      >
        View TeleMed Brochure
      </a>
    </p>
  `,
      },
      {
        question:
          "What is the process for availing of the Annual Physical Examination (APE)?",
        answer: `
    <div class="space-y-4">

      <div>
        <h4 class="font-semibold text-orange-500 mb-2">
          I. Walk-In APE (Individual)
        </h4>

        <p class="text-neutral-600 leading-7">
          The clinic will coordinate directly with Customer Service to secure the necessary approval for your APE availment. Some clinics may still require an endorsement letter from the Customer Service Department before proceeding.
        </p>
      </div>

      <div>
        <h4 class="font-semibold text-orange-500 mb-2">
          II. Walk-In APE (Group)
        </h4>

        <p class="text-neutral-600 mb-2">
          Please provide:
        </p>

        <ul class="list-disc pl-5 space-y-1">
          <li>Masterlist of participants</li>
          <li>Preferred APE date</li>
          <li>Contact person</li>
        </ul>

        <p class="text-neutral-600 leading-7 mt-3">
          Standard processing time is 2–3 weeks before the preferred date.
        </p>
      </div>

      <div>
        <h4 class="font-semibold text-orange-500 mb-2">
          III. Mobile / Onsite APE
        </h4>

        <p class="text-neutral-600 mb-2">
          Please provide:
        </p>

        <ul class="list-disc pl-5 space-y-1">
          <li>Masterlist of participants</li>
          <li>Preferred location and date</li>
          <li>Contact person</li>
        </ul>

        <p class="text-neutral-600 leading-7 mt-3">
          Standard processing time is 3–4 weeks before the preferred date.
        </p>
      </div>

      <div class="bg-orange-50 border border-orange-100 rounded-lg p-4">
        <p class="text-neutral-700">
          Members who personally pay for their APE may file for reimbursement up to the APE assistance amount included in their benefit plan, subject to reimbursement guidelines and requirements.
        </p>
      </div>

      <div>
        <h4 class="font-semibold text-orange-500 mb-2">
          Customer Service Contact Details
        </h4>

        <ul class="space-y-1 text-neutral-600">
          <li><strong>Toll Free:</strong> 1800-10-8-5280480</li>
          <li><strong>Landline:</strong> (02) 8528-0480</li>
          <li><strong>Mobile:</strong> 0922-822-1033</li>
          <li><strong>Mobile:</strong> 0922-822-1035</li>
          <li><strong>Mobile:</strong> 0917-851-8645</li>
          <li><strong>Mobile:</strong> 0998-586-9439</li>
        </ul>
      </div>

    </div>
  `,
      },
      {
        question:
          "What is the process for requesting a replacement card if it is lost?",
        answer: `
    <p class="text-neutral-600 leading-7">
      If your card is lost, please send an email to
      <strong>salesandclientrelations@iwc.com.ph</strong>
      for assistance with the replacement process.
    </p>
  `,
      },
      {
        question: "How much balance remains on my card?",
        answer: `
    <p class="text-neutral-600 leading-7">
      To inquire about your remaining benefits and available balance, please contact:
    </p>

    <ul class="list-disc pl-5 mt-2 space-y-1 text-neutral-600">
      <li>iwc_csu@yahoo.com</li>
      <li>customerservices@iwc.com.ph</li>
      <li>0922-822-1033</li>
      <li>0922-822-1035</li>
      <li>0917-851-8645</li>
      <li>0998-586-9439</li>
    </ul>

    <p class="text-neutral-600 leading-7 mt-3">
      You may also contact our Messenger page:
      <strong>IMS Wellth Care</strong>.
    </p>
  `,
      },
    ];

    const memberFaqsTagalog = [
      {
        question: "Bakit matagal kaming ma-accommodate ng provider?",
        answer: `
      <p class="text-neutral-600 leading-7">
        Ginagawa ng mga provider, pati na rin ng aming customer service team, ang lahat ng makakaya upang ma-accommodate ang lahat ng miyembro sa pinakamaayos at pinakamabilis na paraan. Gayunpaman, may mga pagkakataon na sabay-sabay ang dami ng pasyenteng pinaglilingkuran ng mga ospital o klinika. Sa mga ganitong sitwasyon, hinihiling namin ang inyong pasensya dahil kayo ay maa-accommodate din sa lalong madaling panahon.
      </p>
    `,
      },
      {
        question: "Bakit ako sinisingil ng doktor para sa aking availment?",
        answer: `
      <p class="text-neutral-600 leading-7">
        Maaaring may dalawang pangunahing dahilan: una, maaaring kulang na ang natitirang benepisyo upang masakop ang iyong availment; at pangalawa, maaaring ang diagnosis o kondisyon ay hindi sakop ng inyong benepisyo.
      </p>
    `,
      },
      {
        question:
          "Paano ko malalaman kung ang aking diagnosis ay kabilang sa Exclusion?",
        answer: `
      <p class="text-neutral-600 leading-7">
        Ang aming medical director ang magtatakda kung ito ay kabilang sa exclusions base sa inyong diagnosis. Ilan sa mga halimbawa ng exclusions ay Epilepsy, Auto-immune Diseases, Mental Disorders, at STDs. Para sa kumpletong listahan ng exclusions, mangyaring bisitahin ang aming website na www.iwc.com.ph.
      </p>
    `,
      },
      {
        question: "Bakit kailangan kong magbayad para sa Medical Certificate?",
        answer: `
      <p class="text-neutral-600 leading-7">
        Ang Medical Certificate ay hindi kasama sa saklaw ng plan kaya ito ay may kaukulang bayad na sasagutin ng miyembro. Gayunpaman, nag-aalok kami ng TeleConsult service na nagbibigay ng libre at walang limitasyong medical consultation. Ang Medical Certificate na inisyu sa pamamagitan ng TeleConsult ay ibinibigay nang walang bayad.
      </p>
    `,
      },
      {
        question:
          "Ano ang dapat kong gawin kung may ma-encounter akong issue habang nagge-generate ng LOA sa AMAP?",
        answer: `
      <p class="text-neutral-600 leading-7">
        Kung may ma-encounter kayong issue habang nagge-generate ng LOA sa AMAP, siguraduhin muna na maayos at stable ang inyong internet connection. Maghintay ng limang (5) minuto at subukan muling gumawa ng LOA. Kung magpapatuloy pa rin ang problema, mangyaring mag-email sa contact@amap.iwcsrvr.com para sa karagdagang tulong.
      </p>
    `,
      },
      {
        question:
          "Ano ang dapat kong gawin kung may problema sa TeleMed registration?",
        answer: `
      <p class="text-neutral-600 leading-7">
        Mangyaring sundin ang step-by-step na instruksyon na makikita sa brochure na kasama ng inyong kit. Siguraduhin na tama at kumpleto ang lahat ng impormasyong ilalagay bago magpatuloy sa registration.
      </p>
      <p class="text-neutral-600 leading-7 mt-3">
        Kung makaranas pa rin ng anumang error sa proseso ng registration, mangyaring mag-email sa contact@interactivemedicalfacilities.com para sa karagdagang tulong.
      </p>
    `,
      },
      {
        question:
          "Ano ang proseso para sa pag-avail ng Annual Physical Examination (APE)?",
        answer: `
      <div class="text-neutral-600 leading-7 space-y-3">
        <p><strong>I. Walk-in APE (Individual)</strong><br>
        Para sa mga indibidwal na walk-in APE, ang klinika ay direktang makikipag-ugnayan sa Customer Service upang makuha ang kinakailangang pag-apruba para sa inyong APE availment. Pakitandaan na may ilang klinika na nangangailangan pa rin ng endorsement letter mula sa CSD bago nila maipagpatuloy ang inyong APE.</p>

        <p><strong>II. Walk-in APE (Group)</strong><br>
        Para sa group APE, kinakailangan ang endorsement letter mula sa Customer Service.</p>

        <ul class="list-disc pl-5">
          <li>Masterlist ng mga kalahok</li>
          <li>Nais na petsa ng APE</li>
          <li>Contact person</li>
        </ul>

        <p>Ang standard processing time para sa group walk-in APE ay 2–3 linggo bago ang napiling petsa dahil kinakailangan ang koordinasyon sa malapit na clinic.</p>

        <p><strong>III. Mobile/Onsite APE</strong></p>

        <ul class="list-disc pl-5">
          <li>Masterlist ng mga kalahok</li>
          <li>Nais na lokasyon at petsa ng APE</li>
          <li>Contact person</li>
        </ul>

        <p>Ang standard processing time para sa mobile o onsite APE ay 3–4 linggo bago ang napiling petsa dahil kinakailangan ang koordinasyon sa accredited clinic provider.</p>

        <p>Kung ang miyembro ay nagbayad para sa APE mula sa sariling bulsa, maaari siyang mag-file ng reimbursement claim hanggang sa halagang nakalaan para sa APE assistance sa kanyang benefit plan, alinsunod sa mga itinakdang requirements at guidelines.</p>
      </div>
    `,
      },
      {
        question:
          "Ano ang proseso para humiling ng replacement card kung ito ay nawala?",
        answer: `
      <p class="text-neutral-600 leading-7">
        Kung nawala ang inyong card, mangyaring magpadala ng email sa salesandclientrelations@iwc.com.ph para sa tulong at proseso ng pagpapalit ng card.
      </p>
    `,
      },
      {
        question: "Magkano pa ang natitirang balance sa aking card?",
        answer: `
      <p class="text-neutral-600 leading-7">
        Upang malaman ang natitirang benepisyo at available balance ng inyong card, mangyaring mag-email sa iwc_csu@yahoo.com o customerservices@iwc.com.ph.
      </p>
      <p class="text-neutral-600 leading-7 mt-3">
        Maaari rin kayong makipag-ugnayan sa mga numerong 0922-822-1033, 0922-822-1035, 0917-851-8645, at 0998-586-9439 o mag-message sa aming Messenger na IMS Wellth Care.
      </p>
    `,
      },
    ];

    const switchTab = (tab) => {
      activeTab.value = tab;
      activeIndex.value = null;
    };

    const toggleAccordion = (index) => {
      activeIndex.value = activeIndex.value === index ? null : index;
    };

    const displayedFaqs = computed(() => {
      if (selectedLanguage.value === "ph") {
        return activeTab.value === "member"
          ? memberFaqsTagalog
          : nonmemberFaqsTagalog;
      }

      return activeTab.value === "member"
        ? memberFaqsEnglish
        : nonmemberFaqsEnglish;
    });

    return {
      activeTab,
      activeIndex,
      displayedFaqs,
      switchTab,
      toggleAccordion,
      selectedLanguage,
      memberFaqsTagalog,
      nonmemberFaqsTagalog,
      nonmemberFaqsEnglish,
      memberFaqsEnglish,
      translations,
    };
  },
};
</script>
